import { Text } from '@mantine/core';
import React, { memo } from 'react';
import { NodeProps } from 'reactflow';

export const TextNodeFlow = memo(({ data }: NodeProps) => {
    return (
        <div>
            <Text size={'sm'} fw={700}>
                {data.label}
            </Text>
        </div>
    );
});
